(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('PvDeleteController',PvDeleteController);

    PvDeleteController.$inject = ['$uibModalInstance', 'entity', 'Pv'];

    function PvDeleteController($uibModalInstance, entity, Pv) {
        var vm = this;

        vm.pv = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Pv.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
